import { DndContext, DragOverlay } from '@dnd-kit/core';
import { Box, GlobalStyles } from '@mui/material';
import { ReactNode } from 'react';
import { useMediaApplicationContext } from '../../../../../components/MediaApplicationContext';
import { catalogBannerAspectRatioPadding } from '../../../../../components/useMediaStyles';
import MediaRenderer from '../../../../media/MediaRenderer';
import { CatalogListDragAndDrop } from '../utils/catalogListDragAndDrop.types';

interface CatalogListDragAndDropBoundaryProps {
  dragAndDrop: CatalogListDragAndDrop;
  children: ReactNode;
}

const CatalogListDragAndDropBoundary = ({
  dragAndDrop,
  children,
}: CatalogListDragAndDropBoundaryProps) => {
  const mediaContext = useMediaApplicationContext();

  if (!dragAndDrop.isEnabled) {
    return <>{children}</>;
  }

  const { activeItem } = dragAndDrop;

  return (
    <DndContext {...dragAndDrop.dragAndDropContextProps}>
      {activeItem && <GlobalStyles styles={{ '*': { cursor: 'grabbing !important' } }} />}

      {children}

      <DragOverlay dropAnimation={null} style={{ pointerEvents: 'none', height: 'auto' }}>
        {activeItem && (
          <Box sx={{ overflow: 'hidden', borderRadius: 1.5, backgroundColor: 'secondary.light' }}>
            <MediaRenderer
              type="IMAGE"
              aspectRatio={catalogBannerAspectRatioPadding}
              src={
                activeItem.imageUrl
                  ? mediaContext.getMediaFromSize(activeItem.imageUrl, 'sm')
                  : undefined
              }
            />
          </Box>
        )}
      </DragOverlay>
    </DndContext>
  );
};

export default CatalogListDragAndDropBoundary;
